import { NavigationGuardNext, Route } from 'vue-router';
import { NamedLocation } from '../types';
import { user } from '@/ui/auth/auth';

export function guardOnboardingStatus(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (user.value.organization.onboardingFinished && user.value.admin) {
    const redirectTo: NamedLocation = { name: 'home' };
    next(redirectTo);

    return;
  }

  next();
}
